import { gql } from "@apollo/client";
import { ImageFragment } from "../../fragments/image";

export const QUERY_HOME_PAGE = gql`
  query HomePage {
    homePage {
      headerSection {
        helloLabel
        description
        icon {
          url
        }
      }
      resourceSection {
        title
        description
        viewAllResourcesLabel
        categories: categories_connection {
          nodes {
            documentId
            category
            color
            icon {
              url
            }
            subCategories {
              documentId
              category
              color
            }
            rootCategory {
              documentId
              category
            }
          }
        }
      }
      keyDatesSection {
        title
        description
        viewAllKeyDatesLabel
        icon {
          url
        }
      }
      leadershipWheelSection {
        title
        description
        btnText
        image {
          data {
            ...ImageFragment
          }
        }
      }
      articlesAndPodcastsSection {
        title
        description
        readNowArticle
        viewAllArticle
        listenNowPodcast
        viewAllPodcasts
        icon {
          url
        }
      }
      latestUpdatesSection {
        title
      }
    }
  }
  ${ImageFragment}
`;
